import { API_BASE_URL } from "config";
import { StatusCodes } from "http-status-codes";

import { BaseService } from "./base-service";

export interface CheckLicenseCapOutput {
  /**
   * Indicates whether the license limit has been reached. True if the user cannot order due to capacity limits, false if ordering is allowed.
   */
  isCapReached: boolean;

  /**
   * The alias or identifier of the nearest leader in the organizational hierarchy whose team has exceeded their allocated license limit.
   * Empty string if no leader's limit has been exceeded.
   */
  closestLeaderWithExceededLimit: string;
}

export class AppSenseService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public async checkLicenseCap(
    productTaxonomyId: string,
    shouldSkipValidation: boolean
  ): Promise<CheckLicenseCapOutput> {
    if (shouldSkipValidation) {
      return {
        isCapReached: false,
        closestLeaderWithExceededLimit: "",
      };
    }
    const txId = productTaxonomyId;
    const uriEncodedProductTaxonomyId = encodeURIComponent(txId);

    const endpoint = `/check-license-cap?productTaxonomyId=${uriEncodedProductTaxonomyId}`;

    const response = await this.fetch(endpoint);
    if (response.status !== StatusCodes.OK) {
      throw new Error("An error occurred while checking the license cap.");
    }
    const jsonResponse = await response.json();

    return jsonResponse;
  }
}
